import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

/**
 * Solutions block — the rail down the left draws in as the block scrolls, and
 * each item's connector reaches across to meet it.
 *
 * The rail is scrubbed against scroll position so it tracks the reader rather
 * than playing once; connectors fire per item as each comes into view.
 *
 * Both are decorative, so under prefers-reduced-motion they are simply shown at
 * their finished state.
 *
 * No-ops when the markup isn't present.
 */
function initSolutions() {
  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  document.querySelectorAll("[data-solutions]").forEach((root) => {
    // Guard against double-init if called twice on the same DOM.
    if (root.hasAttribute("data-solutions-initialized")) return;
    root.setAttribute("data-solutions-initialized", "");

    const rail = root.querySelector("[data-solutions-rail]");
    const items = Array.from(root.querySelectorAll("[data-solutions-item]"));
    const connectors = items
      .map((item) => item.querySelector(".block__solutions__connector"))
      .filter(Boolean);

    if (reduceMotion) {
      if (rail) gsap.set(rail, { scaleY: 1 });
      if (connectors.length) gsap.set(connectors, { scaleX: 1 });
      return;
    }

    // Rail — scrubbed, so it draws in step with the scroll rather than
    // animating on a fixed duration once triggered.
    if (rail) {
      gsap.to(rail, {
        scaleY: 1,
        ease: "none",
        scrollTrigger: {
          trigger: root,
          // Starts as the block enters and completes a little before it
          // leaves, so the line is whole while the last item is still read.
          start: "top 75%",
          end: "bottom 85%",
          scrub: 0.5,
        },
      });
    }

    // Connectors — one per item, each firing as its row arrives.
    connectors.forEach((connector) => {
      gsap.to(connector, {
        scaleX: 1,
        duration: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: connector.closest("[data-solutions-item]"),
          start: "top 80%",
          once: true,
        },
      });
    });
  });
}

export { initSolutions };
